export const initialiseFilterAdvancedLocation = (widget: HTMLElement) => {
    const filter = widget.querySelector<HTMLDivElement>('.location-filter')
    if (!filter) return

    const header = filter.querySelector<HTMLHeadingElement>('.header')
    if (!header) return

    const button: HTMLButtonElement = document.createElement('button')
    button.className = header.className
    button.innerHTML = header.innerHTML

    header.replaceWith(button)
    
    const clearSearchInput = filter.querySelector<HTMLInputElement>('.clear-search')
    if (!clearSearchInput) return
    
    const clearSearchButton = document.createElement('button')
    clearSearchButton.id = clearSearchInput.id
    clearSearchButton.className = clearSearchInput.className
    clearSearchButton.type = 'button'

    clearSearchInput.replaceWith(clearSearchButton)
}
